import React from 'react';

import { Flex, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';

interface WeekDaysProps{
    days: number[]
}

export default function WeekDays({ days }:WeekDaysProps) {
  const week = Array.from({ length: 7 }).map((_empty, index) => (dayjs().day(index).format('ddd')[0]));
  return (
    <Flex flexDir="row">
      {week.map((item, index) => (
        <Text
          key={`week-${item}-${index}`}
          ml={1}
          variant="mediumBold"
          color={days.find((day) => Number(day) === index) ? 'primary.default' : 'gray.400'}>
          {item}
        </Text>
      ))}
    </Flex>
  );
}
